"use client";

import { CardStatisticsProps } from "@/types";
import React from "react";
import * as S from "./styles";

const CardStatistics: React.FC<CardStatisticsProps> = ({
  className,
  title,
  value,
  descriptionValue,
  color = "green",
  children,
  colorValue = "colorTitle",
  icon,
  colorIcon = undefined,
  colorPercent = "green",
  percentDescription,
}) => {
  return (
    <S.BoxCard className={className}>
      {icon && <S.BoxIcon $colorIcon={colorIcon}>{icon}</S.BoxIcon>}
      <S.BoxContentCard>
        <S.Value $colorValue={colorValue}>
          {value}
          {descriptionValue && (
            <S.TextColor $color={color}>{descriptionValue}</S.TextColor>
          )}
        </S.Value>
        <S.Title> {title} </S.Title>
        {percentDescription && (
          <S.PercentText $colorPercent={colorPercent}>
            {percentDescription}
          </S.PercentText>
        )}
        {children && children}
      </S.BoxContentCard>
    </S.BoxCard>
  );
};

export default CardStatistics;
